export default __webpack_public_path__ + "static/media/drosten.71aa7a70.png";